<template>
  <div>
    <div v-if="current !== null">

      <Card :loading="loading">
        <div slot="title">Текущий клиент:</div>
        <div class="open-session__user">
          {{ current.user.phone }} - {{ current.user.name }} ({{
            current.user.age | age
          }})
        </div>
      </Card>

      <div class="btn">
        <el-button type="primary"
                   @click="openSession(current)"
                   name="continue">
          Продолжить прием
        </el-button>
      </div>

    </div>

    <div v-if="current === null">

      <div v-if="enableBtn">
        <card :loading="loading" v-if="current === null">
          <el-form
              :model="sessionForm"
              :rules="rulesSendCode"
              label-position="top"
              ref="sessionOpenForm"
              @keyup.enter.native="sendCode"
              class="open-session__form"
          >
            <div slot="title">Новая сессия</div>

            <el-form-item
                prop="department_id"
                class="session-form"
                :error="error"
                label="Название мед. учреждения"
            >
              <el-select
                  class="session-form__select"
                  v-model="sessionForm.department_id"
                  placeholder="Название учреждения"
                  name="department"
              >
                <el-option
                    v-for="item in departmentList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="phone" label="Номер телефона">
              <el-input
                  name="phone"
                  v-model="sessionForm.phone"
                  v-mask="'+7-###-###-##-##'"
                  placeholder="+7-xxx-xxx-xx-xx"
                  auto-complete="off"
              ></el-input>
            </el-form-item>

          </el-form>
        </card>
        <el-button
            type="primary"
            :loading="loadSendCode"
            @click="sendCode"
            name="sendCode">Отправить код
        </el-button>
      </div>

      <div v-if="!enableBtn">
        <card :loading="loading" v-if="current === null">
          <el-form
              :model="sessionForm"
              :rules="rulesCode"
              label-position="top"
              ref="sessionCodeForm"
              @keyup.enter.native="submitForm"
              class="open-session__form"
          >

            <el-form-item prop="code" class="session-form" label="Код подтверджения">
              <el-input
                  ref="sessionCodeFormInput"
                  v-model="sessionForm.code"
                  name="sessionCode"
                  auto-complete="off"
                  placeholder="123456"></el-input>
            </el-form-item>

            <el-input
                v-model="sessionForm.code"
                class="hidden-input"></el-input>
          </el-form>
        </card>

        <el-button
            name="submitForm"
            type="primary"
            :disabled="enableBtn"
            :loading="loadSendForm"
            @click="submitForm"
        >Продолжить
        </el-button>
        <el-button
            name="resendCode"
            type="text"
            v-if="currentTime === 0"
            @click="$refs.sessionCodeForm.resetFields(); enableBtn = !enableBtn"
        >Отправить еще раз
        </el-button>
        <el-button
            v-if="currentTime !== 0"
            type="text"
            disabled
        >Запросить код повторно можно через {{ currentTime | seconds }}
        </el-button>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Vue from "vue";
import VueMask from "v-mask";
import Card from "@/components/elements/Card.vue";

Vue.use(VueMask);

export default {
  name: "session.create",
  data: function () {
    return {
      sessionForm: {
        phone: null,
        code: null,
        department_id: null,
      },
      departmentList: {
        options: [{}],
      },
      rulesSendCode: {
        phone: [
          {required: true, message: "Укажите номер", trigger: "blur"},
          {
            min: 16,
            max: 16,
            message: "Введите все цифры номера",
            trigger: "blur",
          },
        ],
        department_id: [
          {required: true, message: "Укажите название мед. учреждения", trigger: "blur"},
        ],
      },
      rulesCode: {
        code: [
          {required: true, message: "Введите код", trigger: "blur"},
          {
            pattern: /^\d*$/,
            message: "Введите только цифры",
            trigger: "blur",
          },
        ],
      },
      error: null,
      loadSendCode: !1,
      loadSendForm: !1,
      loading: false,
      enableBtn: !0,
      current: null,
      currentTime: 30,
      timerCode: null,
    };
  },
  components: {Card},
  computed: {
    ...mapState("session", {
      session: (state) => state.session,
    })
  },
  created() {
    this.loadLogic()
    this.stopTimer()
  },
  filters: {
    seconds(n) {
      let arr = ["секунду", "секунды", "секунд"];
      return (
          n +
          " " +
          arr[
              n % 100 > 4 && n % 100 < 20
                  ? 2
                  : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? n % 10 : 5]
              ]
      )
    },
    age(n) {
      let arr = ["год", "года", "лет"];
      return (
          n +
          " " +
          arr[
              n % 100 > 4 && n % 100 < 20
                  ? 2
                  : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? n % 10 : 5]
              ]
      );
    },
  },
  watch: {
    currentTime(time) {
      if (time <= 0) {
        this.stopTimer();
      }
    },
  },
  methods: {
    ...mapActions({
      sessionSendCode: "session/SEND_CODE",
      sessionOpen: "session/OPEN",
      editDepartment: "session/EDIT_DEPARTMENT",
      REFRESH: "auth/REFRESH_TOKEN",
    }),
    ...mapMutations({
      setSession: "session/SET_SESSION",
    }),
    loadLogic() {
      this.loading = true;

      this.$api.session
          .current()
          .then((response) => {
            if (response.data.id) {
              this.current = response.data;
              this.loading = false;
            } else this.loadDepartments();
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка сессий 😕",
              message: response.response.data.message,
            });
            this.loading = false;
          })
          .finally(() => {

          });
    },

    startTimer() {
      this.currentTime = 30

      this.timerCode = setInterval(() => {
        this.currentTime--;
      }, 1000);
    },
    stopTimer() {
      clearTimeout(this.timerCode);
    },
    loadDepartments() {

      this.loading = true;

      this.$api.session
          .getDepartments('full')
          .then((response) => {
            this.departmentList = response.data
            if (+localStorage.getItem('department_id')) this.sessionForm.department_id = +(localStorage.getItem('department_id'))
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    REFRESH_TOKEN() {
      this.REFRESH();
    },
    getDataForm() {
      return {
        phone: this.sessionForm.phone.replace(/[^\d]/g, ""),
        code: this.sessionForm.code,
        department_id: this.sessionForm.department_id,
      };
    },
    sendCode() {
      this.error = null;
      if (this.loadSendCode) return

      this.$refs.sessionOpenForm.validate((valid) => {
        if (valid) {
          this.loadSendCode = !0;
          this.sessionSendCode(this.getDataForm())
              .then(() => {
                this.$notify.success({
                  title: "Удачно...",
                  message: "Код был отправлен",
                });
                this.enableCode();
              })
              .catch((response) => {
                this.$notify.error({
                  title: "Ошибка отправки кода 😕",
                  message: response.response.data.message,
                });
              })
              .finally(() => {
                this.loadSendCode = !1;
              });
        }
      });

      localStorage.setItem('department_id', this.sessionForm.department_id)

    },
    openSession(data) {
      this.setSession(data);

      this.$router.push("device")

      if (data.stage === 50) {
        this.$notify.error({
          title: "Что-то пошло не так",
          message: "Данная сесия была закрыта",
        });
        this.$router.push("dashboard")
      }
    },
    enableCode() {
      this.enableBtn = !1;
      this.startTimer()

      this.$nextTick(() => {
        this.$refs.sessionCodeFormInput.focus();
      })
    },
    submitForm() {
      this.error = null;
      this.$refs.sessionCodeForm.validate((valid) => {
        if (valid) {
          this.loadSendForm = !0
          this.$api.session
              .open(this.session.id, this.getDataForm())
              .then((response) => {
                this.editDepartment(this.departmentList[this.sessionForm.department_id])
                this.openSession(response.data)
              })
              .catch((res) => {
                this.$notify.error({
                  title: "Ошибка открытия сесии 😕",
                  message: res.response.data.message,
                })
                this.$nextTick(() => {
                  this.$refs.sessionCodeFormInput.focus();
                })
              })
              .finally(() => {
                this.loadSendForm = !1
              });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box-card {
  max-width: 550px;
  border: 0;
  border-radius: 8px;
  box-shadow: none;
  padding: 10px;
  background: #fff;
  margin-left: 0 !important;

  &__title {
    margin-bottom: 20px;
    font-size: 18px;
  }
}

.open-session {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  @media screen and (max-width: 550px) {
    flex-flow: column wrap;
    flex-wrap: wrap;
  }

  &__user {
    font-size: 14px;
    color: #606266;
  }


  &__form {
    margin-bottom: 10px;
  }
}

.session-form {
  &__select {
    width: 100%;
  }
}

.btn {
  margin-top: 20px;
}

.hidden-input {
  display: none;
}
</style>

